'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var tslib = require('tslib');
require('../../../typography/ErrorText/ErrorText.js');
require('../../../typography/LargeDarkText/LargeDarkText.js');
require('../../../typography/LargeEmphasizedWhiteText/LargeEmphasizedWhiteText.js');
require('../../../typography/MediumDarkText/MediumDarkText.js');
require('../../../typography/MediumEmphasizedDarkText/MediumEmphasizedDarkText.js');
require('../../../typography/MediumText/MediumText.js');
require('../../../typography/MediumWhiteText/MediumWhiteText.js');
require('../../../typography/MiniatureLinkText/MiniatureLinkText.js');
require('../../../typography/SmallDarkText/SmallDarkText.js');
require('../../../typography/SmallDarkTextHeavy/SmallDarkTextHeavy.js');
require('../../../typography/SmallDisabledText/SmallDisabledText.js');
require('../../../typography/SmallEmphasizedDarkText/SmallEmphasizedDarkText.js');
require('../../../typography/SmallEmphasizedDisabledText/SmallEmphasizedDisabledText.js');
require('../../../typography/SmallEmphasizedLinkText/SmallEmphasizedLinkText.js');
require('../../../typography/SmallLinkText/SmallLinkText.js');
var SmallTitleText = require('../../../typography/SmallTitleText/SmallTitleText.js');
require('../../../typography/SmallWhiteText/SmallWhiteText.js');
require('../../../typography/TinyDarkText/TinyDarkText.js');
require('../../../typography/TinyEmphasizedDarkText/TinyEmphasizedDarkText.js');
require('../../../typography/TinyLinkText/TinyLinkText.js');
require('../../../typography/TinyTitleText/TinyTitleText.js');
require('../../../typography/XXLargeDarkText/XXLargeDarkText.js');
var styledComponents = require('./styled-components.js');

var TextWithSort = function (props) {
    var onClick = props.onClick, id = props.id, _a = props.Typography, Typography = _a === void 0 ? SmallTitleText : _a, children = props.children, _b = props.arrowStyleOverrides, arrowStyleOverrides = _b === void 0 ? {} : _b, sorted = props.sorted, _c = props.className, className = _c === void 0 ? '' : _c;
    var isSorted = sorted.column === id;
    var sortClassName = !isSorted ? 'hidden' : 'visible';
    var classes = styledComponents.useStyles();
    var arrow = isSorted && sorted.order === 'desc' ? (React__default.createElement(styledComponents.DownArrow, { className: sortClassName, style: tslib.__assign({}, arrowStyleOverrides) })) : (React__default.createElement(styledComponents.UpArrow, { className: sortClassName, style: tslib.__assign({}, arrowStyleOverrides) }));
    return (React__default.createElement(styledComponents.SortContainer, { className: className },
        React__default.createElement(Typography, { className: classes.typeogrophy, onClick: function () { return onClick(id); } },
            React__default.createElement("span", null, children),
            React__default.createElement("span", null, arrow))));
};

module.exports = TextWithSort;
